import BaseService from './BaseService'
import * as apiroutes from '../apiRoutes'

class NotificationsService extends BaseService {
  constructor() {
    super(apiroutes.NOTIFICATIONS)
  }

  async getAll(params = {}) {
    const normalizedParams = {
      ...params,
      page: Math.max((params.page ?? 1) - 1, 0),
    }

    return await super.getAll(normalizedParams)
  }

  async getUnreadCount() {
    return await super.customCall('GET', '/unread-count', null, null, null)
  }

  async markAsRead(id) {
    return await super.customCall('PATCH', '/' + id + '/read', {}, null, 'json')
  }

  async markAllRead() {
    return await super.customCall('PATCH', '/read-all', {}, null, 'json')
  }
}

const NotificationsServices = new NotificationsService()
export default NotificationsServices
